import { mdiMenu } from "@mdi/js";
import type { JSX } from "solid-js";
import { ActionIcon, type ActionIconProps } from "../ui/icon";

interface SidebarButtonProps
	extends Omit<ActionIconProps<"button">, "path">,
		Omit<JSX.HTMLAttributes<HTMLButtonElement>, "ref"> {}

export function SidebarButton(props: SidebarButtonProps) {
	return (
		<ActionIcon
			path={mdiMenu}
			variant="light"
			{...props}
		/>
	);
}
